import BaseViewController from "./base-view-controller";

class DoctorsListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action) {
    if (name === "selectedData") {
      const {
        member_provider_relation_id,
        pcp_flg,
        provider: {
          first_nm,
          last_nm,
          provider_specialties,
          party_phone_faxes,
          provider_id
        }
      } = text;
      this.formState = {
        ...this.formState,
        doctor_name: `${first_nm} ${last_nm}`,
        doctor_specialty:
          provider_specialties?.[provider_specialties.length - 1]
            ?.specialty_nm ?? "None",
        doctor_phone_button: "???",
        doctor_fax_button: "???",
        first_nm,
        last_nm,
        "provider_specialties.0.provider_taxonomy_cd":
          provider_specialties?.[provider_specialties.length - 1]
            ?.provider_taxonomy_cd,
        pcp_flg,
        provider_id,
        member_provider_relation_id,
        makePrimaryCheckbox: pcp_flg
      };
      if (party_phone_faxes.length) {
        const {
          0: {
            phone_number: phoneNumber0,
            area_code: areaCode0,
            extension: extension0
          } = {},
          1: {
            phone_number: phoneNumber1,
            area_code: areaCode1,
            extension: extension1
          }
        } = party_phone_faxes.slice(-2);
        this.formState = {
          ...this.formState,
          "phone_faxes.0.phone_number": `(${areaCode0}) ${phoneNumber0.substring(
            0,
            3
          )}-${phoneNumber0.substring(3)}`,
          "phone_faxes.0.extension": extension0,
          "phone_faxes.1.phone_number": `(${areaCode1}) ${phoneNumber1.substring(
            0,
            3
          )}-${phoneNumber1.substring(3)}`,
          "phone_faxes.1.extension": extension1
        };
      }
    }
    if (action?.value === "DoctorNew") {
      this.formState = {
        first_nm: "",
        last_nm: "",
        "provider_specialties.0.provider_taxonomy_cd": "",
        "phone_faxes.0.phone_number": "",
        "phone_faxes.0.extension": "",
        "phone_faxes.1.phone_number": "",
        "phone_faxes.1.extension": "",
        pcp_flg: "N"
      };
    }
    super.handleButtonClick(name, text, action);
  }
}

export default DoctorsListViewController;
